import { FETCH_USERS, FETCH_MESSAGES, NO_MESSAGES, SELECT_USER, NEW_MESSAGE, SEND_MESSAGE } from '../../_actions/types';

const defaultState = {
  users: {},
  newMessage: '',
  messages: []
}

export default function ( state = defaultState, action) {
  switch (action.type) {
    case FETCH_USERS:
      return {...state, users: action.payload}
    case FETCH_MESSAGES:
      return {...state, messages: action.messages, recipient: action.recipient }
    case SEND_MESSAGE:
      return {...state}
    case NO_MESSAGES:
      return {...state, messages: action.payload, recipient: action.recipient }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/messenger/messenger_reducer.js